import { render, staticRenderFns } from "./ExpeditionLayout.vue?vue&type=template&id=0f56e809"
import script from "./ExpeditionLayout.vue?vue&type=script&lang=js"
export * from "./ExpeditionLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports